export enum UserRoleLevel {
  SYSTEM = 'SYSTEM',
  ADMIN = 'ADMIN',
  MEMBER = 'MEMBER'
}
